import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {Store} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Container} from 'pixi.js';
import {$BetSelectPopup} from './components/BetSelectPopup';

export class BetSelectPopupModule extends UIModuleV2 {
    static NAME = 'BetSelectPopupModule';

    public static layer = LAYERS.KEYPAD;
    public container = new Container();

    private showPopup = Store.signal(false);

    onInit(): void {
        const uiDefault = $BetSelectPopup({
            showPopup: this.showPopup,
            onClose: () => {
                this.show(false);
                slotStore.soundPlayer.value?.play('buttonclick');
            },
            bet: slotStore.slot_bet,
            bets: slotStore.slot_betList,
            onSetBetIndex: index => this.emitter.emit('UI.bet.setByIndex', index)
        }) as Container;

        this.container.addChild(uiDefault);
    }

    onSetupEvents(): void {
        this.emitter.on('UI.showBetSelectPopup', this.show.bind(this, true));
    }

    private show(show = true): void {
        this.showPopup.value = show;
    }
}